import { Group, Stack } from '@mantine/core';
import type { LiteSecodaEntityOut } from '@repo/api-codegen';
import IconEmojiSelector, {
	iconEmojiSelectorValueToString,
} from '@repo/common/components/IconEmojiSelector';
import { DEFAULT_ICONS } from '@repo/common/constants/defaultIcons';
import { EntityType } from '@repo/common/enums/entityType';
import { EntityPageDescription } from '../../../components/EntityPageLayout';
import EntityPageTitle from '../../../components/EntityPageLayout/EntityPageTitle';
import type { BIDashboardMode } from '../types';

const DEFAULT_ICON = iconEmojiSelectorValueToString(
	DEFAULT_ICONS[EntityType.bi_dashboard]!
);

interface BIDashboardPageHeaderProps {
	entity: LiteSecodaEntityOut;
	mode: BIDashboardMode;
	isReadOnly: boolean;
	onIconChange: (icon: string) => void;
	onTitleChange: (title: string) => void;
	onDescriptionChange: (description: string) => void;
}

export function BIDashboardPageHeader({
	entity,
	mode,
	isReadOnly,
	onIconChange,
	onTitleChange,
	onDescriptionChange,
}: BIDashboardPageHeaderProps) {
	return (
		<Stack spacing="xs">
			<Group spacing="sm" align="flex-start">
				<IconEmojiSelector
					value={entity.icon ?? DEFAULT_ICON}
					onChange={onIconChange}
					entityType={EntityType.bi_dashboard}
					readOnly={isReadOnly}
				/>
				<EntityPageTitle
					entity={{
						title: entity.title ?? '',
						title_cased: entity.title_cased ?? '',
					}}
					placeholder={`Untitled Dashboard`}
					size="xl"
					onChange={onTitleChange}
					isReadOnly={isReadOnly}
					wrapTitle
				/>
			</Group>
			<EntityPageDescription
				entityId={entity.id}
				description={entity.description ?? ''}
				onChange={onDescriptionChange}
				readOnly={isReadOnly}
			/>
		</Stack>
	);
}
